<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/23-FCP-additional-recources.svg"
                class="img-fluid"
                alt="Assess your employability skills"
                srcset=""
              >
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->
    <content-block class="p-4">
      <p>Here are a few other resources to help you in your next steps.</p>
      <ul>
        <li><a
            href="https://www.linkedin.com/learning/professional-networking-for-career-starters"
            target="_blank"
          >Professional networking for career starters</a> (LinkedIn Learning) </li>
        <li><a
            href="https://www.youtube.com/watch?v=Y62E_f3p_e8&list=PLqY1o76wPYOrvLrsro4E0tpafTVB0I6M-&index=6"
            target="_blank"
          >Informational Interviewing: Employability series</a> </li>
        <li><a
            href="https://www.youtube.com/watch?v=7XJAcsQiEfo&list=PLqY1o76wPYOrvLrsro4E0tpafTVB0I6M-&index=4"
            target="_blank"
          >Networking and small talk: Employability series</a></li>
        <li><a
            href="https://www.youtube.com/watch?v=y99QRXBpNcw&list=PLqY1o76wPYOrvLrsro4E0tpafTVB0I6M-&index=2"
            target="_blank"
          >Professionalism in the Workplace</a></li>
        <li><a
            href="https://www.youtube.com/watch?v=T0JS5z4DT8s"
            target="_blank"
          >Demonstrating Professionalism</a></li>
        <li><a
            href="https://www.fullyprepped.ca/"
            target="_blank"
          >Prepped</a> (former RBC career launch)</li>
      </ul>
    </content-block>

    <content-block class="bg-light-grey p-4">
      <p><strong>References</strong></p>
      <ul>
        <li>Foss, J. (2020). A career strategist’s guide to getting a job. LinkedIn. <a
            href="https://www.linkedin.com/learning/a-career-strategist-s-guide-to-getting-a-job/create-a-career-plan?autoSkip=true&autoplay=true&resume=false"
            target="_blank"
          >https://www.linkedin.com/learning/a-career-strategist-s-guide-to-getting-a-job/create-a-career-plan</a></li>
        <li>Big Interview. (2017, April 1). How to Answer: Tell me about yourself. YouTube. <a
            href="https://www.youtube.com/watch?app=desktop&v=MmFuWmzeiDs"
            target="_blank"
          >https://www.youtube.com/watch?app=desktop&v=MmFuWmzeiDs</a></li>
        <li>Big Interview. (2017, April 12). How to Answer: Behavioral Questions. YouTube. <a href="https://www.youtube.com/watch?v=mH3DaeJSwy4" target="_blank">https://www.youtube.com/watch?v=mH3DaeJSwy4</a></li>
        <li>Doyle, A. (2021, January 13). The best ways to get great recommendations on LinkedIn. The Balance Careers. Retrieved August 2, 2022, from <a href="https://www.thebalancecareers.com/how-to-get-linkedin-recommendations-2062316" target="_blank">https://www.thebalancecareers.com/how-to-get-linkedin-recommendations-2062316</a></li>
        <li>Indeed. (2020, January 3). Top Interview Tips: Common Questions, Body Language & More. YouTube. <a href="https://www.youtube.com/watch?v=HG68Ymazo18" target="_blank">https://www.youtube.com/watch?v=HG68Ymazo18</a></li>
        <li>Conference Board of Canada, The. The Employability Skills Toolkit. Ottawa: The Conference Board of Canada, 2022.</li>
        <li>National Association of College and Employers. Competencies for a Career ready workforce. Bethlehem: NACE, 2021.</li>
        <li>Centennial College. Framework for implementing NES in Curriculum. Scarborough: 2016.</li>
        <li>University of Iowa. IOWA GROW. Division of student life, 2009.</li>
      </ul>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock
    // SidebarMenu,
    // Accordion
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
